import type { Offer, CollectionOffers } from './offers'
import type { Inscription } from './types/inscription'
import { activeCollectionOffers } from './offer-book'
import { inscriptionBelongsToCollection } from './inscription-collections'

/** Display eligibility only; build-fill rechecks ownership, traits and the live outpoint. */
export function instantSellOffers(data: CollectionOffers | undefined, slug: string, now: number) {
	return activeCollectionOffers(data, now).filter(
		(o) => o.collection_slug === slug && (o.scope === 'collection' || o.scope === 'trait')
	)
}

export function eligibleSellItems(items: Inscription[], offer: Offer, seller: string) {
	if (!seller || offer.buyer_address === seller || !offer.collection_slug) return []
	return items.filter((item) => {
		if (item.owner !== seller || !inscriptionBelongsToCollection(item, offer.collection_slug!))
			return false
		if (offer.scope === 'collection') return true
		return (
			offer.scope === 'trait' &&
			!!item.meta?.attributes?.some(
				(a) => a.trait_type === offer.trait_type && a.value === offer.trait_value
			)
		)
	})
}
